(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const root = document.querySelector('.header--layout-figma_v2');
    if (!root) return;

    const form = root.querySelector('.header-v2__search-form');
    if (!form) return;

    const input = form.querySelector('.header-v2__search-input');
    const clearBtn = form.querySelector('.header-v2__search-btn--clear');
    const submitBtn = form.querySelector('.header-v2__search-btn--submit');
    if (!input || !clearBtn) return;

    const sync = () => {
      const hasValue = Boolean(input.value && input.value.trim().length);
      form.classList.toggle('is-has-value', hasValue);
      if (submitBtn) submitBtn.disabled = !hasValue;
    };

    sync();
    input.addEventListener('input', sync);
    input.addEventListener('change', sync);

    form.addEventListener('submit', (e) => {
      if (!input.value || !input.value.trim().length) {
        e.preventDefault();
        input.focus();
      }
    });

    clearBtn.addEventListener('click', (e) => {
      e.preventDefault();
      input.value = '';
      sync();
      input.focus();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
